export default "__VITE_ASSET__Cuy6OCji__"